import { useCallback, useContext, useEffect, useState } from "react";
import { geocodeByAddress, getLatLng } from "react-places-autocomplete";
import { useService } from "../../../hooks";
import { NavigatorContext } from "../../../context";

export const useFranchise = () => {
  const { navigateTo } = useContext(NavigatorContext);
  const { fetchByAttr } = useService("Data", "franchise");
  const { setTitle, setDescription, setKeywords } = useService("Meta");
  const { urlToSplitData, getLocationData } = useService("Router");
  const [image, setimage] = useState([]);
  const [title, settitle] = useState<string>("");
  const [slug, setslug] = useState<string>("");
  const [content, setcontent] = useState<string>("");
  const [owner, setowner] = useState<string>("");
  const [contactPerson, setcontactPerson] = useState<any>();
  const [address, setaddress] = useState<string>("");
  const [addressDetail, setaddressDetail] = useState<any>();
  const [companyName, setcompanyName] = useState<string>("");
  const [email, setemail] = useState<string>("");
  const [mobile, setmobile] = useState<string>("");
  const [city, setcity] = useState<string>("");
  const [places, setplaces] = useState([]);
  const [socialLinks, setsocialLinks] = useState(null);

  const urlData = urlToSplitData(getLocationData().pathname);
  const urlSlug = urlData[2];

  const handleSelect = useCallback(async (address) => {
    geocodeByAddress(address)
      .then((results) => getLatLng(results[0]))
      .then((latLng) => {
        let places = [];
        places.push(latLng);
        if (latLng !== null) {
          setplaces(places);
        }
      })
      .catch((e) => console.log("error", e));
  }, []);

  const getFranchiseData = useCallback(async (query) => {
    const result = await fetchByAttr(query);
    if (result.status) {
      if (result.data[0].status !== "publish")
        navigateTo({ route: "/error404" });
      else {
        const franchiseData = result.data[0];
        const addressDetail = JSON.parse(franchiseData.addressDetail);
        setTitle(franchiseData.metaTitle ?? franchiseData.title);
        setDescription(franchiseData.metaDescription);
        setKeywords(JSON.parse(franchiseData.metaKeyword));
        settitle(franchiseData.title);
        setslug(franchiseData.slug);
        setcontent(franchiseData.content);
        setimage(JSON.parse(franchiseData.image));
        setcompanyName(franchiseData.companyName);
        setemail(franchiseData.email);
        setmobile(franchiseData.mobile);
        setaddress(franchiseData.address);
        setowner(JSON.parse(franchiseData.owner));
        setcontactPerson(JSON.parse(franchiseData.contactPerson));
        setaddressDetail(addressDetail);
        setsocialLinks(JSON.parse(franchiseData.socialLinks));
        addressDetail.address_components?.forEach((l) => {
          if (l.types?.includes("administrative_area_level_2")) {
            setcity(l.long_name);
          }
        });
      }
    }
  }, [fetchByAttr, navigateTo, setDescription, setKeywords, setTitle]);

  useEffect(() => {
    if (slug !== urlSlug) getFranchiseData({ slug: urlSlug });
  }, [slug, urlSlug, getFranchiseData]);

  useEffect(() => {
    handleSelect(address);
  }, [address, handleSelect]);
  return {
    image,
    title,
    companyName,
    city,
    content,
    addressDetail,
    places,
    address,
    email,
    contactPerson,
    mobile,
    socialLinks,
  };
};
